<template>
  <div>
    <AtomContainer>
      <Accordion>
        <AccordionItem v-for="item in list" :key="item.name" :item="item" class="-md:border-gray-100">
          <template slot="accordion-trigger">
            <AtomTitle
              class="relative top-[0.4vw]"
              tag="h1"
              class-name="-md:flex"
              :sup="item.sup"
              class-name-sup="md:!text-base md:!top-2 -md:!left-2 md:!left-0 -md:leading-[130%] -md:!top-0"
              >{{ item.title }}</AtomTitle
            >
          </template>
          <template slot="accordion-content">
            <div class="lists">
              <div v-for="listItem in item.list" :key="listItem.name" class="w-full" @click="modalItem = listItem">
                <MoleculeListTitleImage :list="listItem" />
              </div>
            </div>
          </template>
        </AccordionItem>
      </Accordion>
    </AtomContainer>
    <Modal v-if="modalItem" :title="modalItem.label" :img="modalItem.image" @close="modalItem = null">
      <template #controls>
        <div class="flex flex-wrap gap-3">
          <AtomButton tag="a" href="/" class="btn btn-sm group">
            По записи
            <svg
              class="ml-[10px]"
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                class="group-hover:stroke-white"
                d="M5 7.625H9.375"
                stroke="#282929"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                class="group-hover:stroke-white"
                d="M5 10.125H7.7375"
                stroke="#282929"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                class="group-hover:stroke-white"
                d="M6.25 3.75H8.75C10 3.75 10 3.125 10 2.5C10 1.25 9.375 1.25 8.75 1.25H6.25C5.625 1.25 5 1.25 5 2.5C5 3.75 5.625 3.75 6.25 3.75Z"
                stroke="#282929"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                class="group-hover:stroke-white"
                d="M10 2.51251C12.0812 2.62501 13.125 3.39376 13.125 6.25001V10C13.125 12.5 12.5 13.75 9.375 13.75H5.625C2.5 13.75 1.875 12.5 1.875 10V6.25001C1.875 3.40001 2.91875 2.62501 5 2.51251"
                stroke="#282929"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </AtomButton>
          <AtomButton tag="span" class="btn btn-sm btn-outline disabled">
            Платное
            <svg
              class="ml-[10px]"
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.42188 8.95615C5.42188 9.7624 6.04063 10.4124 6.80938 10.4124H8.37812C9.04687 10.4124 9.59062 9.84365 9.59062 9.14365C9.59062 8.38115 9.25937 8.1124 8.76562 7.9374L6.24687 7.0624C5.75312 6.8874 5.42188 6.61865 5.42188 5.85615C5.42188 5.15615 5.96562 4.5874 6.63437 4.5874H8.20312C8.97187 4.5874 9.59062 5.2374 9.59062 6.04365"
                stroke="#282929"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M7.5 3.75V11.25" stroke="#282929" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M7.5 13.75C10.9518 13.75 13.75 10.9518 13.75 7.5C13.75 4.04822 10.9518 1.25 7.5 1.25C4.04822 1.25 1.25 4.04822 1.25 7.5C1.25 10.9518 4.04822 13.75 7.5 13.75Z"
                stroke="#282929"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </AtomButton>
        </div>
      </template>
      <div class="flex flex-col gap-y-10 mb-10">
        <MoleculeModalRowButton v-for="item in modalItem.tags" :key="item.name" :item="item" />
      </div>
      <MoleculeModalRowText :item="modalItem.text" />
      <MoleculeModalRowProgress v-for="item in modalItem.progress" :key="item.name" :item="item" />
      <div class="flex flex-col md:grid grid-cols-7 md:gap-x-4 mb-16">
        <div class="col-span-5 col-start-3">
          <AtomButton tag="a" href="/" class="btn btn-lg btn-fill uppercase -md:w-full">Записаться</AtomButton>
        </div>
      </div>
      <template #footer>
        <MoleculeModalRowButton v-for="item in modalItem.footer" :key="item.name" :item="item" />
      </template>
    </Modal>
  </div>
</template>

<script>
import Accordion from '../../../atoms/accordion/AtomAccordion'
import AccordionItem from '../../../atoms/accordion/AtomAccordionItem'
import AtomButton from '../../../atoms/AtomButton'
import AtomTitle from '../../../atoms/AtomTitle'
import AtomContainer from '../../../atoms/layouts/AtomContainer'
import MoleculeListTitleImage from '../../../molecules/layouts/MoleculeListTitleImage'
import MoleculeModalRowButton from '../../../molecules/modals/MoleculeModalRowButton'
import MoleculeModalRowProgress from '../../../molecules/modals/MoleculeModalRowProgress'
import MoleculeModalRowText from '../../../molecules/modals/MoleculeModalRowText'
import Modal from '../../../templates/layouts/Modal'

export default {
  name: 'OrganismAccordion',
  components: {
    MoleculeModalRowProgress,
    MoleculeModalRowButton,
    MoleculeModalRowText,
    AtomContainer,
    AtomButton,
    AtomTitle,
    Accordion,
    AccordionItem,
    MoleculeListTitleImage,
    Modal,
  },
  props: ['list'],
  data() {
    return {
      modalItem: null,
    }
  },
}
</script>

<style lang="postcss" scoped>
.lists {
  &:hover {
    .item {
      @apply md:text-gray-500;
      ::v-deep path {
        @apply stroke-gray-500;
      }
    }
  }
}
</style>
